import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "details-panel" }
const _hoisted_2 = { class: "details-grid" }
const _hoisted_3 = { class: "details-row" }
const _hoisted_4 = { class: "details-val" }
const _hoisted_5 = { class: "details-row" }
const _hoisted_6 = { class: "details-val details-val--cyan" }
const _hoisted_7 = { class: "details-row" }
const _hoisted_8 = { class: "details-val" }
const _hoisted_9 = { class: "details-row" }
const _hoisted_10 = { class: "details-val" }
const _hoisted_11 = { class: "details-row" }
const _hoisted_12 = { class: "details-val" }
const _hoisted_13 = { class: "details-row" }
const _hoisted_14 = { class: "details-val" }
const _hoisted_15 = { class: "details-row" }
const _hoisted_16 = { class: "details-val" }
const _hoisted_17 = { class: "details-row" }
const _hoisted_18 = { class: "details-val" }
const _hoisted_19 = { class: "details-row" }
const _hoisted_20 = { class: "details-row" }

import type { User } from "@/types/user";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserAccountDetails',
  props: {
    user: {}
  },
  setup(__props: any) {



function formatDate(dateStr: string): string {
  return new Date(dateStr).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "details-title" }, "Account Details", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "details-key" }, "Full Name", -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.user.fullName), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "details-key" }, "Username", -1)),
        _createElementVNode("span", _hoisted_6, "@" + _toDisplayString(__props.user.username), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "details-key" }, "Email", -1)),
        _createElementVNode("span", _hoisted_8, _toDisplayString(__props.user.email), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "details-key" }, "Phone", -1)),
        _createElementVNode("span", _hoisted_10, _toDisplayString(__props.user.phone), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "details-key" }, "Role", -1)),
        _createElementVNode("span", _hoisted_12, _toDisplayString(__props.user.role), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "details-key" }, "Address", -1)),
        _createElementVNode("span", _hoisted_14, _toDisplayString(__props.user.address), 1)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "details-key" }, "Created At", -1)),
        _createElementVNode("span", _hoisted_16, _toDisplayString(formatDate(__props.user.createdAt)), 1)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "details-key" }, "Last Login", -1)),
        _createElementVNode("span", _hoisted_18, _toDisplayString(formatDate(__props.user.lastLogin)), 1)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "details-key" }, "Active", -1)),
        _createElementVNode("span", {
          class: _normalizeClass([
            'details-val',
            __props.user.isActive ? 'details-val--green' : 'details-val--red',
          ])
        }, _toDisplayString(__props.user.isActive ? "Yes" : "No"), 3)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "details-key" }, "Logged In", -1)),
        _createElementVNode("span", {
          class: _normalizeClass(['details-val', __props.user.isLoggedIn ? 'details-val--cyan' : ''])
        }, _toDisplayString(__props.user.isLoggedIn ? "Yes" : "No"), 3)
      ])
    ])
  ]))
}
}

})